import WpBlockEditor from "../../_modules/_WpBlockEditor";

WpBlockEditor();
